import type { ThemeProps } from '@radix-ui/themes'

export const THEME_PROPS = {
  accentColor: 'orange',
  grayColor: 'gray',
  radius: 'medium'
} as const satisfies ThemeProps
